import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Carousel, { CarouselProps } from '../components/carousel';

interface CarouselElement extends Element {
  props: Element['props'] &
    CarouselProps & {
      'data-erom-slides-per-view'?: string;
      'data-erom-slides-per-group'?: number;
      'data-erom-space-between'?: number;
      'data-erom-speed'?: number;
      'data-erom-navigation'?: string;
      'data-erom-pagination'?: string;
      'data-erom-loop'?: string;
      'data-erom-autoplay'?: string;
      'data-erom-autoplay-speed'?: number;
      'data-erom-breakpoints'?: string;
      'data-erom-effect'?: string;
      'data-erom-theme-color'?: string;
      'data-erom-centered-slides'?: string;
    };
}

const carousel: Processor<CarouselElement> = {
  priority: 96,
  name: 'carousel',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('erom-carousel-block'),
  processor: ({ node }) => {
    const {
      'data-erom-slides-per-view': slidesPerView,
      'data-erom-slides-per-group': slidesPerGroup,
      'data-erom-space-between': spaceBetween,
      'data-erom-speed': speed,
      'data-erom-navigation': navigation,
      'data-erom-pagination': pagination,
      'data-erom-loop': loop,
      'data-erom-autoplay': autoplay,
      'data-erom-autoplay-speed': autoplaySpeed,
      'data-erom-breakpoints': breakpoints,
      'data-erom-effect': effect,
      'data-erom-theme-color': themeColor,
      'data-erom-centered-slides': centeredSlides
    } = node.props;

    node.props = {
      ...node.props,
      slidesPerView,
      slidesPerGroup,
      spaceBetween,
      speed,
      navigation: navigation === 'true',
      pagination: pagination === 'true',
      loop: loop === 'true',
      autoplay: autoplay === 'true',
      autoplaySpeed,
      effect,
      themeColor,
      centeredSlides: centeredSlides === 'true',
      breakpoints: breakpoints ? JSON.parse(breakpoints) : undefined
    };

    node.component = Carousel as ComponentType;

    return node;
  }
};

export default carousel;
